/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener('DOMContentLoaded', function() {

//   var a = document.querySelector('.slideshow__text-wrapper .button-group__wrapper a:nth-of-type(2)');
//   if (a != null) {
//   	a.href = '#durability';
//   }
  	
  var anchor = document.querySelector('#shopify-section-template--15536385818800__image-with-text section');
  if (anchor != null) {
    anchor.setAttribute('id','durability');
  }
  
  // var cart = document.querySelector('#AddToCart .loader-button__text');
  // if (cart != null) {
  //   cart.innerHTML = 'ORDER';
  // }

    var cart = document.querySelector('#AddToCart .loader-button__text');
  if (cart != null) {
    cart.innerHTML = 'ADD TO CART';
  }

  var learnmore = document.querySelector('#shopify-section-template--15536385818800__slideshow .button-group__wrapper .button:nth-of-type(2)');
   if ( learnmore != null) {
     learnmore.setAttribute("data-src", "#modal");
     learnmore.setAttribute("data-fancybox", '');
   }
}, false);


// PRODUCT DESCRIPTIONS CHANGE OUT

$(document).ready(function(){
  var prodTitle = $(".product-meta__title").text();
  console.log("Product Title: "+prodTitle);

  if(prodTitle=="Nest & Wild Luxury Hybrid"){
    $("#block-template--16117265367216__product-content-5c339632-3da1-424f-b7e0-da5a5e2a3ad2 .product-tabs__tab-item-content").html('<div class="product-tabs__tab-item-content rte"><p><strong>Built for sleep. </strong><p>The Nest & Wild mattress is made with ventilated, high density foam and PCM cooling technology to deliver comfort, support and a good night’s sleep.<p><p><strong>Sleep Cooler</strong><br>Experience cooler sleep with high airflow and heavy cooling cover.<p><p><strong>Sleep Comfortably<br></strong>Sleeping on this bed feels like sleeping on a cloud but you will not sink in or get stuck in the bed. This bed is perfectly designed for side sleepers.<p><strong>Less Back Pain<br></strong>With amazing support your back will stay aligned which is critical for lower back pains and aches. This kind of support helps you stay asleep long to avoid tossing and turning.<p><strong>Handles<br></strong>We added two handles on both side of the mattress to make handling easier.<p><strong>Firm Edges<br></strong>Increased firmness on the edges of the bed making getting in and out of the bed easier. Improves your experience if you often sit on the bed.<p><strong>Durability<br></strong>No matter if it is trucks, lawn mowers, clothes or mattresses weight equals durability. Our beds are durable because they are just plain heavier. Our Queen Hybrid weighs an average of 120lbs.<p><strong>Risk Free<br></strong>Enjoy a 99 night trail on us and a 10 year warranty.<p><strong>Safe<br></strong>Free of Fiberglass or harmful chemicals.<p><p>For more warranty and shipping information <strong>, </strong><em><strong>visit our </strong></em><a href=/pages/faq title=FAQ><em><strong>FAQ page</strong> </em></a><em><strong>.</strong> </em><strong> </strong></div>');
  }
  if(prodTitle=="Nest & Wild Original Mattress"){
    $("#block-template--16117265367216__product-content-5c339632-3da1-424f-b7e0-da5a5e2a3ad2 .product-tabs__tab-item-content").html('<div class="product-tabs__tab-item-content rte"><p><strong>Built for sleep. </strong><br>The Nest & Wild mattress is made with ventilated, high density foam and PCM cooling technology to deliver comfort, support and a good night’s sleep.<p><p><strong>Sleep Cooler</strong><br>Experience cooler sleep with high airflow and heavy cooling cover treating with Phase Change Material.<p><p><strong>Sleep Comfortably<br></strong>Sleeping on this bed feels like sleeping on a bed slightly softer than a medium. The bed will contour to our body but still works for back and side sleepers alike.<p><strong>Less Back Pain<br></strong>With amazing support your back will stay aligned which is critical for lower back pains and aches. This kind of support helps you stay asleep long to avoid tossing and turning.<p><strong>Durability<br></strong>No matter if it is trucks, lawn mowers, clothes or mattresses weight equals durability. Our beds are durable because they are just plain heavier. Our Queen All Foam weighs an average of 95lbs.<p><strong>Risk Free<br></strong>Enjoy a 99 night trail on us and a 10 year warranty.<p><strong>Safe<br></strong>Free of Fiberglass or harmful chemicals.<p><p>For more warranty and shipping information <strong>, </strong><em><strong>visit our </strong></em><a href=/pages/faq title=FAQ><em><strong>FAQ page</strong> </em></a><em><strong>.</strong> </em><strong> </strong></div>');
  }
  if(prodTitle=="Nest & Wild All Foam Classic"){
    $("#block-template--16117265367216__product-content-5c339632-3da1-424f-b7e0-da5a5e2a3ad2 .product-tabs__tab-item-content").html('<div class="product-tabs__tab-item-content rte"><p><strong>Built for sleep. </strong><br>The Nest & Wild mattress is made with ventilated, high density foam to deliver comfort, support and a good night’s sleep.<p><p><strong>Sleep Comfortably<br></strong>Sleeping on this bed feels like sleeping on medium firm bed. The bed will contour to our body but still works for back and side sleepers alike.<p><strong>Less Back Pain<br></strong>With amazing support your back will stay aligned which is critical for lower back pains and aches. This kind of support helps you stay asleep long to avoid tossing and turning.<p><strong>Durability<br></strong>No matter if it is trucks, lawn mowers, clothes or mattresses weight equals durability. Our beds are durable because they are just plain heavier. Our Queen All Foam weighs an average of 75lbs.<p><strong>Risk Free<br></strong>Enjoy a 99 night trail on us and a 10 year warranty.<p><strong>Safe<br></strong>Free of Fiberglass or harmful chemicals.<p><p>For more warranty and shipping information <strong>, </strong><em><strong>visit our </strong></em><a href=/pages/faq title=FAQ><em><strong>FAQ page</strong> </em></a><em><strong>.</strong> </em><strong> </strong></div>');
  }

});
